import { render, staticRenderFns } from "./SetUsers.vue?vue&type=template&id=67fb8f1e&scoped=true&"
import script from "./SetUsers.vue?vue&type=script&lang=js&"
export * from "./SetUsers.vue?vue&type=script&lang=js&"
import style0 from "./SetUsers.vue?vue&type=style&index=0&id=67fb8f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb8f1e",
  null
  
)

export default component.exports